

































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import FormLayout from './FormLayout.vue';
import DatepickerEntry from '@/components/datepicker/DatepickerEntry.vue';
import ConfirmModal from '@/components/modal/ConfirmModal.vue';
import BaseSelect from '@/components/select/BaseSelect.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';

import { formatDateInterval } from '../utils';

import { VacationSlot } from '../types';
import { ISODateRange } from '@/utils/date/types';

@Component({
    components: {
        FormLayout,
        DatepickerEntry,
        ConfirmModal,
        BaseSelect,
        BaseButton,
    },
})
export default class FormVacationEdit extends Vue {
    @Prop({ required: true }) vacation!: VacationSlot

    form: ISODateRange = this.vacation.dates
    confirmRemovalModal = false

    get readableDateRange() {
        return formatDateInterval(this.vacation.dates);
    }

    @Watch('vacation')
    resetVacationDates() {
        this.form = this.vacation.dates;
    }
    
    updateVacation() {
        this.$emit('vacation:update', {
            vacation: this.vacation,
            dates: this.form,
        })
    }

    askVacationRemove() {
        this.confirmRemovalModal = true;
    }

    closeModal() {
        this.confirmRemovalModal = false;
    }

    removeVacation() {
        this.$emit('vacation:remove', this.vacation);
    }

    closeForm() {
        this.$emit('vacation:cancel');
    }
}
